import React from "react";
import { createRoot } from 'react-dom/client';

import FamilyTreeApp from './components/FamilyTreeApp';

if (document !== null) {
  const root = createRoot(document.getElementById("root")!);
  root.render(<FamilyTreeApp />);
}
